import s from './styles.scss';
import cx from 'classnames';
import { Circle, CircleProps } from './Circle';

export interface CirclesProps {
  outerCircleProps: Omit<CircleProps, 'className'>;
  innerCircleProps?: Omit<CircleProps, 'className'>;
  className?: string;
}

export const Circles = ({
  outerCircleProps,
  innerCircleProps,
  className,
}: CirclesProps) => {
  return (
    <div className={cx(s.progressCircles, className)}>
      <Circle {...outerCircleProps} className={cx(s.outer, s.large)} />
      {innerCircleProps && (
        <Circle {...innerCircleProps} className={cx(s.inner, s.small)} />
      )}
    </div>
  );
};
